export const App_TYPES = {
  // Services
  CacheService: Symbol.for('CacheService'),
  CommentsEncryptionService: Symbol.for('CommentsEncryptionService'),
  DocLoader: Symbol.for('DocLoader'),
  DocsApi: Symbol.for('DocsApi'),
  EventBus: Symbol.for('EventBus'),
  HttpService: Symbol.for('HttpService'),
  LocalStorageEncryptionService: Symbol.for('LocalStorageEncryptionService'),
  Logger: Symbol.for('Logger'),
  MetricService: Symbol.for('MetricService'),
  PublicDocLoader: Symbol.for('PublicDocLoader'),
  RealtimeEncryptionService: Symbol.for('RealtimeEncryptionService'),
  RecentDocumentsService: Symbol.for('RecentDocumentsService'),
  WebsocketService: Symbol.for('WebsocketService'),
  Database: Symbol.for('Database'),
  SizeTracker: Symbol.for('SizeTracker'),

  // Use cases
  CreateComment: Symbol.for('CreateComment'),
  CreateDocument: Symbol.for('CreateDocument'),
  CreateEmptyDocumentForConversion: Symbol.for('CreateEmptyDocumentForConversion'),
  CreateInitialCommit: Symbol.for('CreateInitialCommit'),
  CreateNewDocument: Symbol.for('CreateNewDocument'),
  FetchRealtimeToken: Symbol.for('FetchRealtimeToken'),
  CreateThread: Symbol.for('CreateThread'),
  DecryptComment: Symbol.for('DecryptComment'),
  DecryptCommit: Symbol.for('DecryptCommit'),
  DecryptMessage: Symbol.for('DecryptMessage'),
  DuplicateDocument: Symbol.for('DuplicateDocument'),
  EncryptComment: Symbol.for('EncryptComment'),
  EncryptMessage: Symbol.for('EncryptMessage'),
  ExportAndDownload: Symbol.for('ExportAndDownload'),
  FetchMetaAndRawCommit: Symbol.for('FetchMetaAndRawCommit'),
  GetCommitData: Symbol.for('GetCommitData'),
  GetDocumentKeys: Symbol.for('GetDocumentKeys'),
  GetDocumentMeta: Symbol.for('GetDocumentMeta'),
  GetNode: Symbol.for('GetNode'),
  GetNodePermissions: Symbol.for('GetNodePermissions'),
  HandleRealtimeCommentsEvent: Symbol.for('HandleRealtimeCommentsEvent'),
  LoadCommit: Symbol.for('LoadCommit'),
  LoadDocument: Symbol.for('LoadDocument'),
  LoadThreads: Symbol.for('LoadThreads'),
  SquashAlgorithm: Symbol.for('SquashAlgorithm'),
  SquashDocument: Symbol.for('SquashDocument'),
  VerifyCommit: Symbol.for('VerifyCommit'),
  VerifyMessages: Symbol.for('VerifyMessages'),

  // Api
  ApiEditComment: Symbol.for('ApiEditComment'),
  ApiAddCommentToThread: Symbol.for('ApiAddCommentToThread'),
  ApiCreateThread: Symbol.for('ApiCreateThread'),
  ApiGetThread: Symbol.for('ApiGetThread'),
  RouteExecutor: Symbol.for('RouteExecutor'),
}
